import { Address } from '@website/types/graphqlOperations';
import React, { useMemo } from 'react';
import countryAddressDetails from 'postal-address-field-names';
import SettingItemRow from './SettingItemRow';

interface AddressFieldViewProps {
  address: Address;
}

/**
 * View Address Fields - With Localization Support
 */
export default function AddressFieldsView({ address }: AddressFieldViewProps) {
  // Get the country-specific address fields
  const countryOptions = useMemo(() => {
    return countryAddressDetails.find((i) => i.iso === address.country);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address]);
  return (
    <>
      {address.givenName && (
        <SettingItemRow fieldName="First Name" value={address.givenName} />
      )}
      {address.familyName && (
        <SettingItemRow
          fieldName="Last Name"
          value={address.familyName ?? ''}
        />
      )}
      <SettingItemRow fieldName="Country" value={countryOptions.name} />
      {!!countryOptions.fields.addressLine1 && (
        <SettingItemRow
          fieldName={countryOptions.fields.addressLine1}
          value={address.addressLine1 ?? ''}
        />
      )}
      {!!countryOptions.fields.addressLine2 && (
        <SettingItemRow
          fieldName={countryOptions.fields.addressLine2}
          value={address.addressLine2 ?? ''}
        />
      )}
      {!!countryOptions.fields.dependentLocality && (
        <SettingItemRow
          fieldName={countryOptions.fields.dependentLocality}
          value={address.dependentLocality ?? ''}
        />
      )}
      {!!countryOptions.fields.locality && (
        <SettingItemRow
          fieldName={countryOptions.fields.locality}
          value={address.locality ?? ''}
        />
      )}
      {!!countryOptions.fields.administrativeArea && (
        <SettingItemRow
          fieldName={countryOptions.fields.administrativeArea}
          value={address.administrativeArea ?? ''}
        />
      )}
      {!!countryOptions.fields.postalCode && (
        <SettingItemRow
          fieldName={countryOptions.fields.postalCode}
          value={address.postalCode ?? ''}
        />
      )}
    </>
  );
}
